// src/utils/apiHelpers.js

/**
 * Safe fetch wrapper that handles errors and validates responses
 */
export const safeFetch = async (url, options = {}) => {
  try {
    const response = await fetch(url, {
      method: options.method || 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });

    // Check if response is ok (status 200-299)
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`API Error ${response.status}:`, errorText);
      throw new Error(`Server returned ${response.status}: ${errorText.substring(0, 100)}`);
    }

    // Try to parse JSON
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

/**
 * Safely access array elements with validation
 */
export const safeArrayAccess = (array, index = 0, fallback = null) => {
  if (!Array.isArray(array)) {
    console.warn('Expected array but got:', typeof array);
    return fallback;
  }
  
  if (array.length === 0) {
    console.warn('Array is empty');
    return fallback;
  }
  
  if (index >= array.length) {
    console.warn(`Index ${index} out of bounds for array of length ${array.length}`);
    return fallback;
  }
  
  return array[index];
};

/**
 * Safely access nested object properties
 */
export const safeGet = (obj, path, fallback = null) => {
  const keys = path.split('.');
  let result = obj;
  
  for (const key of keys) {
    if (result === null || result === undefined || typeof result !== 'object') {
      return fallback;
    }
    result = result[key];
  }
  
  return result !== undefined ? result : fallback;
};

/**
 * Check if response data is valid
 */
export const isValidResponse = (response) => {
  return response && 
         typeof response === 'object' && 
         !Array.isArray(response) &&
         response.data !== undefined;
};